import { Box, SelectChangeEvent, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Modal, Radio, TextField } from "@mui/material";
// import * as React from "react";
// import { Grid, SelectChangeEvent, Typography, Stack, Box } from "@mui/material";
import { RadioProps } from '@mui/material/Radio';
import  { FC, useState, useEffect } from "react";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { styled } from '@mui/material/styles';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { fetchBankById, fetchBanks } from '../../store/bankStore/bankThunk';
import qrImage from '../../assets/qr-image.png';
import { fetchGstOptions } from "../../store/gstStore/gstThunk";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0ms',
    width: 425,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));
  
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});
  
// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
    return (
        <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
        />
    );
}

interface PayToProps {
    account: any;
    onChangePayTo: (data: any) => void;
    payToObj: any;
    props?: any
}
  

const BankChanges: FC<PayToProps> = ({ account, onChangePayTo, payToObj, props}) => {

    const [selectedBank, setSelectedBank] = useState<any>();
    const [selectedBankData, setSelectedBankData] = useState<any>([]);
    const [bankOptions, setBankOptions] = useState<IOptions[]>([]);
    const { banks } = useAppSelector(state => state.banks);
    const dispatch = useAppDispatch();


    //Fetch all the accounts on Accounts page load.
    useEffect(() => {
        if (account) {
        dispatch(fetchBanks(account._id));
        }
    }, [dispatch, account]);

    const handleChange = (_id: number) => {
        let currentBank = banks.find((item: any) => item._id === _id);
        setSelectedBankData(currentBank);
        let paytoObj = {
            "bankAccount": _id,
            "copyBankAccountDetails": {
                "accountName": currentBank?.accountName,
                "accountNumber": currentBank?.accountNumber,
                "IFSC": currentBank?.IFSC,
                "bankName": currentBank?.bankName,
                "qrCodeLink": account.qrCodeUrl
            }
        };
        setSelectedBank(paytoObj)
        onChangePayTo(paytoObj)
        props.setVisible(false)

    };

    // Select first bank name on form load.
    useEffect(() => {
        if (bankOptions.length > 0 && account) {
            if (!selectedBank && payToObj) {
                setSelectedBank(payToObj.bankAccount)
                setSelectedBankData(payToObj.copyBankAccountDetails);
            } else if (payToObj === undefined) {
                setSelectedBank(bankOptions[0].value)
                let currentBank = banks.find((item: any) => item._id === bankOptions[0].value);
                setSelectedBankData(currentBank);
                let paytoObj = {
                    "bankAccount": bankOptions[0].value,
                    "copyBankAccountDetails": {
                        "accountName": currentBank?.accountName,
                        "accountNumber": currentBank?.accountNumber,
                        "IFSC": currentBank?.IFSC,
                        "bankName": currentBank?.bankName,
                        "qrCodeLink": account.qrCodeUrl
                    }
                };
                onChangePayTo(paytoObj);
            }
            
        }
    }, [bankOptions, banks, selectedBank, payToObj, account]);

    
    useEffect(() => {
        let isMounted = true;
        const getBankDetails = async () => {
            let options: IOptions[] = [];
            if (banks.length > 0) {
                const bankAccountArr = banks;
                await bankAccountArr.forEach(async (_id: string | any) => {
                let id = (typeof _id === 'string') ? _id : _id._id
                const bd: any = await dispatch(fetchBankById(id));
                options.push({ label: bd.payload.bankName, value: bd.payload._id })
                if (isMounted && bankOptions.length == 0) {
                    setBankOptions((bankOptions: any) => ([...bankOptions, { label: bd.payload.bankName, value: bd.payload._id }]));
                }
                });
            }
        }
        getBankDetails();
        return () => {
        isMounted = false;
        };
    }, [banks, dispatch]);

    const onClose = () => {
        props.setVisible(false)
    }

    return(
        <Modal
            open={props.visible}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    props.setVisible(true)
                }
            }}
        >
            <Box sx={style}>
            <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    <IconButton size='small' onClick={onClose} style={{marginRight:-5}} >
                        <HighlightOffOutlinedIcon  color="error"/>
                    </IconButton>
                </div>
                <h3  style={{marginTop:-2}}>Change Bank </h3>
                {/* {JSON.stringify(selectedBank)} */}
                </Grid>
                
            </Grid>
                <List component="nav" aria-label="main mailbox folders">
                    {banks && banks.length > 0 && banks.map((bank:any, itemIndex:number) => 
                        <>
                            <ListItem 
                                secondaryAction={
                                    <BpRadio checked={ selectedBank ? selectedBank.bankAccount === bank._id : false} onChange={()=>handleChange(bank._id)} size="small" style={{marginRight:-10}}/>
                                }
                                disablePadding
                                key={bank._id}>
                                <ListItemButton selected={selectedBank ? selectedBank.bankAccount === bank._id : false} onClick={() => handleChange(bank._id)} dense >
                                    <ListItemText>{bank.bankName}, {bank.branchName} | {bank.accountNumber}
                                        {/* <div style={{borderRadius:25,float:'left',marginTop:1,marginRight:5, fontSize:10,width:16,height:16, color:'#fff',backgroundColor:'#2586c2',border:'1px solid #196b9e',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center',fontWeight:600}}>
                                            P
                                        </div>  */}
                                </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        </>
                    )}
                </List>
            </Box>
        </Modal>
    )
};
export default BankChanges;